import {h, Fragment} from "preact"
import { useCurrencyFormatting } from "@nosto/preact"

export default function Swatches({ relatedProducts, product }) { 
    const { format } = useCurrencyFormatting()

    console.log('Terry Swatches', relatedProducts, product)

    function handleSwatch(e, prod){
        e.preventDefault();
        if(e.target.classList.contains("active")){
            return
        }
        var productCard = e.target.closest(".ns-product");
        productCard.querySelector(".ns-color.active")?.classList.remove("active");
        productCard.querySelector(".ns-swatch.active")?.classList.remove("active");
        e.target.classList.add("active");
        e.target.closest(".ns-color")?.classList.add("active");

        productCard.querySelector(".ns-info-title").textContent = prod.name;
        productCard.querySelector(".ns-current-price").textContent = format(prod.price);
        productCard.querySelector(".ns-listprice").textContent = format(prod.listPrice);

        if(prod.price != prod.listPrice){
            productCard.querySelector(".ns-listprice.ns-hidden")?.classList.remove("ns-hidden");
            productCard.querySelector(".ns-current-price")?.classList.add("discounted");
        } else {
            productCard.querySelector(".ns-listprice").classList.add("ns-hidden");
            productCard.querySelector(".ns-current-price.discounted")?.classList.remove("discounted");
        }

        productCard.querySelector(".ns-image").setAttribute("src", prod.imageUrl);
        console.log('Terry?!?!?!?', prod)
        const altImage = prod.alternateImageUrls[0] ? prod.alternateImageUrls[0] : prod.imageUrl;
        console.log('Terry', altImage);
        productCard.querySelector(".ns-alt-img .ns-image").setAttribute("src", altImage);
        // productCard.querySelectorAll(".quick-shop-select option").forEach((option) => {
        //     option.style.display = "none";
        //     if(option.getAttribute("productId") == prod.productId) {
        //         option.style.display = "block";
        //     }
        // })

        productCard.querySelectorAll(".quick-shop-select").forEach((select) => {
            const prodId = select.getAttribute('data-id');
            if (prodId == prod.productId) {
                select.style.display = "block";
            } else {
                select.style.display = "none";
            }
        })

        productCard.querySelector(".quick-shop-add").setAttribute("data-id", prod.productId);

        productCard.querySelector("a").setAttribute("href", prod.url);

        //reset QuickShop
        productCard.querySelector(".quick-shop-close").click();
        productCard.querySelector(".choose-size").selected = true;
        productCard.querySelector(".quick-shop-add").disabled = true;
    }

    var preSelectedProduct = relatedProducts.find(prod => prod.productId == product.productId);
    var tempIndex = relatedProducts.indexOf(preSelectedProduct);

    Array.prototype.move = function(from,to){
        this.splice(to,0,this.splice(from,1)[0]);
        return this;
    };
    relatedProducts = relatedProducts.move(tempIndex, 0);
    relatedProducts = relatedProducts.filter((prod, index) => {
        return index === 0 || prod.availability !== "OutOfStock";
    });
    return(
        <div class="ns-colors custom-color-selectors" onClick={(e)=>{e.preventDefault()}}>
            {   
                relatedProducts?.map((prod, index) => {
                console.log('Terry productssss', prod)
                var colorStyle = prod?.skus?.[0]?.attributes?.find(attr => attr.key == "Color")?.value;
                var colorData = window.color_data.find(color => color.color_name == colorStyle.toLowerCase())?.color_data;
                var isFirst = prod.productId == product.productId;
                colorStyle = colorStyle.toLowerCase().replaceAll(" ", "-");
            
                return (
                    <>
                    {index < 5 &&
                        <a 
                            href={prod.url}
                            class={`ns-color ${isFirst ? 'first active' : ''}`} 
                            title={prod.name}
                            onClick={(e) => handleSwatch(e, prod)}
                        >
                            {/* <span class={`ns-swatch ns-color-${colorStyle} color-${colorData} ${isFirst ? 'first active' : ''}`} style={`background: ${colorData};`}></span> */}
                            <span class={`ns-swatch ns-color-${colorStyle} ${isFirst ? 'first active' : ''}`} style={`background: ${colorData};`}></span>
                        </a>
                    }
                    {relatedProducts?.length > 5 && index == 5 &&
                        <span class="ns-left">+{relatedProducts.length - 5}</span>
                    }
                    </>
                )
            })}
        </div>
    )
}